import './index.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteLocation, useLink } from 'react-router-stack';
import {
  EmptyData,
  ErrorMessage,
  HeaderWithTimer,
  PlaceHolder,
  RouteWrapper,
  ScreenImageBackground,
  View
} from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import Constants from '../../../constants';
import { hideLoader, showErrorToast, showToast } from '../../../actions/app-actions-types';
import FlatList from 'flatlist-react';
import {
  addSubstitutePlayer,
  getSubstituteTeamById
} from '../../../actions/fantasy-substitute-action-types';
import {
  SubbedPlayerRow,
  SubstituteOperationModal,
  SubstitutePlayerRow,
  SubstitutionPlayerRow,
  TeamPreviewHeader,
  TeamPreviewPlayerHeader
} from '../../component';
import _ from 'underscore';

const SubstituteTeam = () => {
  const { state = {} as any } = useRouteLocation();
  const navigate = useLink();
  const dispatch = useDispatch();
  const [sectionPlayerList, setSectionPlayerList] = useState([] as any[]);
  const [playerList, setPlayerList] = useState([] as any[]);
  const [resultArrived, setResultArrived] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [substitutedPlayers, setSubstitutedPlayers] = useState({});
  const [selectedItem, setSelectedItem] = useState({} as any);
  const [substitutedPlayersList, setSubstitutedPlayersList] = useState({} as any);
  const [error, setError] = useState(false);
  const [substituteOperationModal, setSubstituteOperationModal] = useState(false);
  const [substitutedCaptainId, setSubstitutedCaptainId] = useState('');
  const [substitutedViceCaptainId, setSubstitutedViceCaptainId] = useState('');
  const [teamAFInningsPlayerCount, setTeamAFInningsPlayerCount] = useState(0);
  const [teamBFInningsPlayerCount, setTeamBFInningsPlayerCount] = useState(0);
  const [teamASInningsPlayerCount, setTeamASInningsPlayerCount] = useState(0);
  const [teamBSInningsPlayerCount, setTeamBSInningsPlayerCount] = useState(0);
  const [originalPlayerList, setOriginalPlayerList] = useState([]);
  const { item: matchItem = {} } = useSelector((state: any) => state.fantasy_substitute);
  const {
    matchTeamLock = false,
    teamA = {},
    teamB = {},
    substitutionStatus = '',
    tabType = 'FIXTURE'
    // completed = false
    // status=0
  } = matchItem;

  const { teamData, matchAllPlayersList = [], isMyUser = false, isLeaderboard = false } = state;
  const {
    captainId = '',
    viceCaptainId = '',
    _id: teamId = '',
    score: userTeamScore = 0,
    teamNumber = 1,
    username = ''
  } = teamData;

  useEffect(() => {
    if (isMyUser && !matchTeamLock) {
      getSubstituteTeam();
    } else setInitialTeamData(teamData);
    if (isMyUser && !matchTeamLock) {
      EventEmitter.on('SubstituteTeamPlayer', getSubstituteTeam);
      return () => {
        EventEmitter.off('SubstituteTeamPlayer', getSubstituteTeam);
      };
    }
  }, []);

  useEffect(() => {
    window.addEventListener('popstate', onClickBrowserBack);
    return () => {
      window.addEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onClickBrowserBack = () => {
    setSubstituteOperationModal(false);
  };

  const onPressSubstitute = (item: { isCaptain?: any; isViceCaptain?: any; id?: any }) => {
    let teamASInningsPlayerCount_ = teamASInningsPlayerCount,
      teamBSInningsPlayerCount_ = teamBSInningsPlayerCount;
    const { isCaptain = false, isViceCaptain = false } = item;
    if ((isCaptain && substitutedViceCaptainId) || (isViceCaptain && substitutedCaptainId)) {
      dispatch(showErrorToast('substitution not allowed for both captain and vice captain'));
      return;
    }
    if ([...playerList, ...substitutedPlayersList].length >= 14) {
      dispatch(showErrorToast('Only 3 substitution allowed'));
      return;
    }
    const { id = '' } = item;
    let secondInningsPlayerList: {
      id: any;
      playerId: any;
      substitutePlayerId: null;
      state: number;
      substitutePlayerRating: any;
    }[] = [];
    let oldPlayerData = {};
    let substitutionPlayers: any = {};
    playerList.forEach((item: any) => {
      if (id != item.id) {
        if (item.substitutePlayerObj && item.substitutePlayerObj.rating) {
          const { substitutePlayerObj } = item;
          secondInningsPlayerList.push({
            id: substitutePlayerObj.id,
            playerId: substitutePlayerObj.playerId,
            substitutePlayerId: null,
            state: 0,
            substitutePlayerRating: substitutePlayerObj.rating
          });
          substitutionPlayers[item.id] = 1;
        } else {
          secondInningsPlayerList.push({
            id: item.id,
            playerId: item.playerId,
            substitutePlayerId: null,
            state: 0,
            substitutePlayerRating: item.rating
          });
        }
      } else {
        if (item?.teamId === teamA?.teamId) {
          teamASInningsPlayerCount_--;
        } else {
          teamBSInningsPlayerCount_--;
        }
        oldPlayerData = {
          id: item.id,
          playerId: item.playerId
        };
      }
    });

    navigate.push('/substitute_team_player', {
      teamId,
      item: matchItem,
      oldPlayerData,
      secondInningsPlayerList,
      captainId,
      viceCaptainId,
      substitutedCaptainId,
      substitutedViceCaptainId,
      substitutedPlayers,
      substitutedPlayersList,
      teamAFInningsPlayerCount,
      teamBFInningsPlayerCount,
      teamASInningsPlayerCount: teamASInningsPlayerCount_,
      teamBSInningsPlayerCount: teamBSInningsPlayerCount_,
      originalPlayerList,
      substitutionPlayers,
      teamData
    });
  };

  const onPressBack = () => {
    setSubstituteOperationModal(false);
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const renderItemPlayers = (item: any) => {
    let {
      substitutePlayerId = null,
      substitutePlayerObj = {},
      state = 0,
      points = 0,
      halfInningPoints = 0,
      isCaptain = false,
      isViceCaptain = false
    } = item;

    let { points: substitutePoints = 0, halfInningPoints: substituteHalfInningPoints = 0 } =
      substitutePlayerObj;

    points = isCaptain ? points * 2 : isViceCaptain ? points * 1.5 : points;
    halfInningPoints = isCaptain
      ? halfInningPoints * 2
      : isViceCaptain
      ? halfInningPoints * 1.5
      : halfInningPoints;

    substituteHalfInningPoints = isCaptain
      ? substituteHalfInningPoints * 2
      : isViceCaptain
      ? substituteHalfInningPoints * 1.5
      : substituteHalfInningPoints;

    substitutePoints = isCaptain
      ? substitutePoints * 2
      : isViceCaptain
      ? substitutePoints * 1.5
      : substitutePoints;

    let playerObj = item;
    const isSubstitutionActive =
      matchTeamLock && substitutionStatus == 'SUBSTITUTED' && state === 4;

    if (isSubstitutionActive) {
      playerObj = substitutePlayerObj;
      substitutePlayerObj = item;
    }

    const isShowSubstitution = isMyUser || matchTeamLock || tabType === 'RESULT';
    const isShowSubstitutionBtn = isMyUser && !matchTeamLock;

    return (
      <View className={'substitute-player-container'}>
        {substitutePlayerId && isShowSubstitution ? (
          <View className={'substitute-item'}>
            <SubbedPlayerRow
              item={substitutePlayerObj}
              onPressSubstitute={() => {}}
              btnTitle={isSubstitutionActive ? 'Subbed' : 'Substitution'}
              points={isSubstitutionActive ? halfInningPoints : 0}
              completed={isLeaderboard}
              isTeamTeamA={teamA?.teamId === substitutePlayerObj?.teamId ? true : false}
              lineupsOut={false}
              isShowSubstitutionBtn={false}
            />
            <View className={'substitute-refresh-container'}>
              <Constants.Svgs.SubstituteRefresh />
            </View>
            <SubstitutionPlayerRow
              item={playerObj}
              onPressSubstitute={() => onPressSubstitution(item)}
              isShowSubstitutionBtn={isShowSubstitutionBtn}
              btnTitle={isSubstitutionActive ? 'Substitution' : 'To be subbed'}
              points={isSubstitutionActive ? substitutePoints - substituteHalfInningPoints : points}
              isCaptain={isCaptain}
              isViceCaptain={isViceCaptain}
              completed={isLeaderboard}
              isTeamTeamA={teamA?.teamId === playerObj?.teamId ? true : false}
              lineupsOut={false}
            />
          </View>
        ) : (
          <SubstitutePlayerRow
            item={isSubstitutionActive ? playerObj : item}
            onPressSubstitute={onPressSubstitute}
            isShowSubstitutionBtn={isShowSubstitutionBtn}
            btnTitle={'Substitute'}
            points={points}
            isCaptain={isCaptain}
            isViceCaptain={isViceCaptain}
            completed={isLeaderboard}
            isTeamTeamA={
              isSubstitutionActive
                ? teamA?.teamId === playerObj?.teamId
                  ? true
                  : false
                : teamA?.teamId === item?.teamId
                ? true
                : false
            }
            lineupsOut={false}
          />
        )}
      </View>
    );
  };

  const renderList = (list: any[]) => {
    return <View className={'substitute-flat-list'}>{list.map(renderItemPlayers)}</View>;
  };

  const renderSectionList = (item: any) => {
    return (
      <View>
        <TeamPreviewPlayerHeader title={item.title} />
        {renderList(item.data)}
      </View>
    );
  };

  const getSubstituteTeam = ({ substituteTeamData = {} as any } = {}) => {
    const { isLoader = false } = substituteTeamData;
    const data = {
      teamId,
      isLoader
    };
    dispatch(
      getSubstituteTeamById({
        data,
        callback: ({ result = {}, error }: { result: any; error: any }) => {
          if (!error && result) {
            setInitialTeamData(result);
          } else {
            setError(true);
          }
        }
      })
    );
  };

  const countInningsPlayers = (result: { players?: never[] | undefined }) => {
    const { players = [] } = result;

    let teamAFInningsPlayerCount = 0;
    let teamBFInningsPlayerCount = 0;
    let teamASInningsPlayerCount = 0;
    let teamBSInningsPlayerCount = 0;
    players.forEach((item: { state: number; teamId: any }) => {
      if (item.state == 0) {
        if (teamA?.teamId === item?.teamId) {
          teamAFInningsPlayerCount++;
          teamASInningsPlayerCount++;
        } else {
          teamBFInningsPlayerCount++;
          teamBSInningsPlayerCount++;
        }
      } else if (item.state == 1) {
        if (teamA?.teamId === item?.teamId) {
          teamAFInningsPlayerCount++;
        } else {
          teamBFInningsPlayerCount++;
        }
      } else if (item.state == 2) {
        if (teamA?.teamId === item?.teamId) {
          teamASInningsPlayerCount++;
        } else {
          teamBSInningsPlayerCount++;
        }
      }
    });
    setTeamAFInningsPlayerCount(teamAFInningsPlayerCount);
    setTeamBFInningsPlayerCount(teamBFInningsPlayerCount);
    setTeamASInningsPlayerCount(teamASInningsPlayerCount);
    setTeamBSInningsPlayerCount(teamBSInningsPlayerCount);
  };

  const setInitialTeamData = (result: {
    players?: any;
    substitutedCaptainId?: any;
    substitutedViceCaptainId?: any;
  }) => {
    const { players = [], substitutedCaptainId = '', substitutedViceCaptainId = '' } = result;
    let substitutedPlayers: any = {};
    let substitutedPlayersList: any[] = [];
    const substitutePlayerList = players.filter(
      (x: { substitutePlayerId: any }) => x.substitutePlayerId
    );
    let newList: any[] = [];
    players.forEach((item: { playerId: any }) => {
      let substituteObj = _.findWhere(substitutePlayerList, {
        substitutePlayerId: item.playerId
      });
      if (!substituteObj) {
        newList.push(item);
      } else {
        substitutedPlayers[substituteObj.substitutePlayerId] = 1;
        substitutedPlayersList.push({
          playerId: substituteObj.substitutePlayerId,
          state: 0
        });
      }
    });
    setSubstitutedCaptainId(substitutedCaptainId);
    setSubstitutedViceCaptainId(substitutedViceCaptainId);
    setSubstitutedPlayers(substitutedPlayers);
    setSubstitutedPlayersList(substitutedPlayersList);
    setInitialData(newList);
    setOriginalPlayerList(players);
    countInningsPlayers(result);
  };

  const onPressRetry = () => {
    getSubstituteTeam();
  };

  const setInitialData = (players: any[]) => {
    let sectionPlayerList = [];
    let wkKeepersList: any[] = [];
    let batsmanList: any[] = [];
    let allRoundersList: any[] = [];
    let bowlersList: any[] = [];
    players.forEach(
      (itemA: { playerId: any; id: any; substitutePlayerId: any; teamId: any; role: any }) => {
        let substitutePlayerObj = {} as any;
        const playerObj = matchAllPlayersList.find(
          (o: { id: any }) => o.id === itemA.playerId || o.id === itemA.id
        );
        if (itemA.substitutePlayerId) {
          substitutePlayerObj = matchAllPlayersList.find(
            (o: { id: any }) => o.id === itemA.substitutePlayerId
          );
        }

        if (substitutePlayerObj) {
          substitutePlayerObj = {
            ...substitutePlayerObj,
            teamName:
              teamA?.teamId === substitutePlayerObj?.teamId ? teamA?.shortName : teamB?.shortName
          };
        }
        const playerItem = {
          ...itemA,
          ...playerObj,
          isCaptain:
            captainId === itemA.id ||
            captainId === itemA.playerId ||
            captainId === itemA.substitutePlayerId
              ? true
              : false,
          isViceCaptain:
            viceCaptainId === itemA.id ||
            viceCaptainId === itemA.playerId ||
            viceCaptainId === itemA.substitutePlayerId
              ? true
              : false,
          substitutePlayerId: itemA.substitutePlayerId,
          substitutePlayerObj,
          teamName: teamA?.teamId === itemA?.teamId ? teamA?.shortName : teamB?.shortName
        };

        switch (itemA.role) {
          case 'wk':
            wkKeepersList.push(playerItem);
            break;
          case 'wkbat':
            wkKeepersList.push(playerItem);
            break;
          case 'bat':
            batsmanList.push(playerItem);
            break;
          case 'all':
            allRoundersList.push(playerItem);
            break;
          case 'bowl':
            bowlersList.push(playerItem);
            break;
        }
      }
    );
    if (wkKeepersList.length > 0) {
      sectionPlayerList.push({
        title: 'Wicket Keepers',
        data: wkKeepersList
      });
    }
    if (batsmanList.length > 0) {
      sectionPlayerList.push({
        title: 'Batters',
        data: batsmanList
      });
    }
    if (allRoundersList.length > 0) {
      sectionPlayerList.push({
        title: 'All Rounders',
        data: allRoundersList
      });
    }
    if (bowlersList.length > 0) {
      sectionPlayerList.push({
        title: 'Bowlers',
        data: bowlersList
      });
    }
    dispatch(hideLoader());
    setResultArrived(true);
    setError(false);
    setSectionPlayerList(sectionPlayerList);
    setForceUpdate(!forceUpdate);
    setPlayerList([...wkKeepersList, ...batsmanList, ...allRoundersList, ...bowlersList]);
  };

  const renderWhenEmpty = () => {
    if (!resultArrived) return <PlaceHolder.Loader loadingMessage={''} />;
    if (error) return <ErrorMessage onPressRetry={onPressRetry} />;
    return <EmptyData message={'No Team Found'} />;
  };

  const onPressDelete = () => {
    setSubstituteOperationModal(false);
    let newPlayerList: any = [];
    playerList.forEach((item) => {
      if (item.substitutePlayerId === selectedItem.substitutePlayerId) {
        newPlayerList.push({
          playerId: item.id,
          state: 0
        });
        // eslint-disable-next-line no-empty
      } else if (selectedItem.substitutePlayerId === item.id) {
      } else if (item.substitutePlayerId) {
        newPlayerList.push({
          playerId: item.id,
          substitutePlayerId: item.substitutePlayerId,
          state: 0
        });
      } else {
        newPlayerList.push({
          playerId: item.id,
          state: 0
        });
      }
    });
    substitutedPlayersList.forEach((item: { playerId: any }) => {
      if (item.playerId != selectedItem.substitutePlayerId) {
        newPlayerList.push(item);
      }
    });
    let data = {
      teamId,
      captainId,
      viceCaptainId,
      players: newPlayerList,
      substitutedCaptainId,
      substitutedViceCaptainId
    } as any;

    if (selectedItem.substitutePlayerId === substitutedCaptainId) delete data.substitutedCaptainId;
    else if (selectedItem.substitutePlayerId === substitutedViceCaptainId)
      delete data.substitutedViceCaptainId;

    dispatch(
      addSubstitutePlayer({
        data,
        callback: ({ error }: { error: any }) => {
          setError(false);
          if (!error) {
            dispatch(showToast('Substitute deleted successfully'));
            EventEmitter.emit('teamUpdate', {});
            getSubstituteTeam();
          } else {
            setError(true);
          }
        }
      })
    );
  };

  const onPressClose = () => {
    setSubstituteOperationModal(false);
  };

  const onPressSubstitution = (item: any) => {
    setSelectedItem(item);
    setSubstituteOperationModal(true);
  };

  const onCalledDeadline = () => {
    navigate.replace('/', { replace: true });
  };

  return (
    <RouteWrapper>
      <ScreenImageBackground>
        <HeaderWithTimer
          onlyTitle={true}
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          gameType={Constants.GameType.FANTASY_SUBSTITUTION}
        />
        <View className={'substitute-container'}>
          <TeamPreviewHeader
            username={username}
            teamA={teamA}
            teamB={teamB}
            teamNumber={teamNumber}
            completed={isLeaderboard}
            userTeamScore={userTeamScore}
          />

          <FlatList
            list={sectionPlayerList}
            renderWhenEmpty={renderWhenEmpty}
            renderItem={renderSectionList}
            renderOnScroll
          />
        </View>
        <SubstituteOperationModal
          visible={substituteOperationModal}
          onPressClose={onPressClose}
          onPressDelete={onPressDelete}
        />
      </ScreenImageBackground>
    </RouteWrapper>
  );
};

export default SubstituteTeam;
